import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const NAV_ADMIN = [
  { section: 'Principal', items: [
    { key: 'dashboard', icon: '⬡', label: 'Dashboard' },
  ]},
  { section: 'Gestión', items: [
    { key: 'stock', icon: '◈', label: 'Stock' },
    { key: 'ventas', icon: '◎', label: 'Ventas' },
    { key: 'prestamos', icon: '⇄', label: 'Préstamos' },
    { key: 'movimientos', icon: '≡', label: 'Movimientos' },
  ]},
  { section: 'Embajadoras', items: [
    { key: 'embajadoras', icon: '◉', label: 'Embajadoras' },
  ]},
  { section: 'Experiencias', items: [
    { key: 'calendario', icon: '▦', label: 'Calendario' },
    { key: 'experiencias', icon: '◆', label: 'Experiencias' },
  ]},
];

const NAV_EMBAJADORA = [
  { section: 'Principal', items: [
    { key: 'dashboard', icon: '⬡', label: 'Dashboard' },
  ]},
  { section: 'Mi gestión', items: [
    { key: 'stock', icon: '◈', label: 'Mi Stock' },
    { key: 'ventas', icon: '◎', label: 'Mis Ventas' },
    { key: 'prestamos', icon: '⇄', label: 'Préstamos' },
    { key: 'movimientos', icon: '≡', label: 'Movimientos' },
  ]},
  
];

export default function Sidebar({ active, setActive }) {
  const { userData, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = userData?.role === 'admin' ? NAV_ADMIN : NAV_EMBAJADORA;

  const handleNav = (key) => { setActive(key); setOpen(false); };

  return (
    <>
      <button className="hamburger" onClick={() => setOpen(o => !o)}>
        ☰ &nbsp;FLORESIENDO
      </button>
      {open && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 99, background: 'rgba(0,0,0,0.5)' }}
          onClick={() => setOpen(false)}
        />
      )}
      <aside className={`sidebar${open ? ' open' : ''}`}>
        <div className="sidebar-logo">
          FLORESIENDO
          <span className="sidebar-logo-sub">Sistema interno</span>
        </div>
        <div className="sidebar-user">
          <div className="sidebar-user-name">{userData?.name || 'Usuario'}</div>
          <div className="sidebar-user-role">{userData?.role === 'admin' ? 'Administradora' : 'Embajadora'}</div>
        </div>
        <nav className="sidebar-nav">
          {nav.map(section => (
            <div key={section.section}>
              <div className="nav-section-label">{section.section}</div>
              {section.items.map(item => (
                <div
                  key={item.key}
                  className={`nav-item${active === item.key ? ' active' : ''}`}
                  onClick={() => handleNav(item.key)}
                >
                  <span className="nav-item-icon">{item.icon}</span>
                  {item.label}
                </div>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="btn btn-ghost" style={{ width: '100%' }} onClick={logout}>
            Cerrar sesión
          </button>
        </div>
      </aside>
    </>
  );
}